import { createApp } from 'vue';
import DocxToPdfConverter from '@/Components/DocxToPdfConverter.vue';
import '@styles/app.css';

createApp(DocxToPdfConverter).mount('#docx-to-pdf-converter');
